import { forwardRef } from 'react';

import { motion } from 'motion/react';

const SliderSideMotion = forwardRef(function SliderSideMotion(
  {
    children,
    keyProp,
    isBackward = false,
    className = '',
    disabled = false,
    duration = 0.15,
    stiffness = 300,
    damping = 30,
    opacity = 0,
    delay = 0,
    xAxis = 100,
    transition = {},
    turnOffOpacityTransition = false,
    exitSlideOnly = false,
    ...rest
  },
  ref,
) {
  const exit = disabled
    ? false
    : exitSlideOnly
      ? { x: isBackward ? -xAxis : xAxis }
      : { opacity: 0 };

  return (
    <motion.div
      ref={ref}
      key={keyProp}
      initial={disabled ? false : { opacity, x: isBackward ? -xAxis : xAxis }}
      animate={disabled ? false : { opacity: 1, x: 0 }}
      exit={exit}
      className={className}
      transition={{
        duration,
        x: { type: 'spring', stiffness, damping, delay },
        opacity: turnOffOpacityTransition ? false : { duration, delay },
        ...transition,
      }}
      {...rest}>
      {children}
    </motion.div>
  );
});

export default SliderSideMotion;
